<template>
    <Layout>
        <template slot="body">
            <div class="card card-modern pt-3" style="border: none; box-shadow: none;">
                <div class="modern-header" style="display: flex; align-items: center; gap: 15px; margin-bottom: 20px;">
                    <div class="header-icon" style="background: #fff7ed; color: #ff9800; width: 48px; height: 48px; border-radius: 12px; display: flex; align-items: center; justify-content: center;">
                        <i class="material-icons" style="font-size: 24px; margin: 0;">manage_accounts</i>
                    </div>
                    <h4 class="card-title" style="margin: 0; font-size: 1.5rem; color: #1e293b;">Cadastrar usuário</h4>
                </div>
                <div class="card-body">
                    <h6 class="mt-3">Dados gerais</h6>
                    <hr>

                    <div class="form-group">
                        <div class="input-group">
                            <div class="input-group-prepend">
                                <span class="input-group-text">
                                    <i class="material-icons">account_box</i>
                                </span>
                            </div>
                            <input id="input-nome" v-model="nome" type="text" placeholder="Nome" class="form-control">
                        </div>
                    </div>

                    <div class="form-group">
                        <div class="input-group">
                            <div class="input-group-prepend">
                                <span class="input-group-text">
                                    <i class="material-icons">email</i>
                                </span>
                            </div>
                            <input id="input-email" v-model="email" type="text" placeholder="E-mail (solarmap@nome_empresa.com.br)" class="form-control">
                        </div>
                    </div>

                    <div class="form-group">
                        <div class="input-group">
                            <div class="input-group-prepend">
                                <span class="input-group-text">
                                    <i class="material-icons">phone</i>
                                </span>
                            </div>
                            <input id="input-telefone" v-model="telefone" type="text" placeholder="Telefone" class="form-control">
                        </div>
                    </div>

                    <div class="form-group">
                        <div class="input-group">
                            <div class="input-group-prepend">
                                <span class="input-group-text">
                                    <i class="material-icons">lock_outline</i>
                                </span>
                            </div>
                            <input id="input-senha" autocomplete="new-password" v-model="senha" type="password" placeholder="Senha" class="form-control">
                        </div>
                    </div>

                    <div class="form-group">
                        <div class="input-group">
                            <div class="input-group-prepend">
                                <span class="input-group-text">
                                    <i class="material-icons">lock_outline</i>
                                </span>
                            </div>
                            <input id="input-confirmar-senha" v-model="confirmarSenha" type="password" placeholder="Confirmar senha" class="form-control">
                        </div>
                    </div>

                    <h6 class="mt-5">Contato 1</h6>
                    <hr>

                    <div class="form-group">
                        <div class="input-group">
                            <div class="input-group-prepend">
                                <span class="input-group-text">
                                    <i class="material-icons">account_box</i>
                                </span>
                            </div>
                            <input id="input-nome-contato-1" v-model="nomeContato1" type="text" placeholder="Nome" class="form-control">
                        </div>
                    </div>

                    <div class="form-group">
                        <div class="input-group">
                            <div class="input-group-prepend">
                                <span class="input-group-text">
                                    <i class="material-icons">email</i>
                                </span>
                            </div>
                            <input id="input-email-contato-1" v-model="emailContato1" type="text" placeholder="E-mail" class="form-control">
                        </div>
                    </div>

                    <div class="form-group">
                        <div class="input-group">
                            <div class="input-group-prepend">
                                <span class="input-group-text">
                                    <i class="material-icons">phone</i>
                                </span>
                            </div>
                            <input id="input-telefone-contato-1" v-model="telefoneContato1" type="text" placeholder="Telefone" class="form-control">
                        </div>
                    </div>

                    <h6 class="mt-5">Contato 2</h6>
                    <hr>

                    <div class="form-group">
                        <div class="input-group">
                            <div class="input-group-prepend">
                                <span class="input-group-text">
                                    <i class="material-icons">account_box</i>
                                </span>
                            </div>
                            <input id="input-nome-contato-2" v-model="nomeContato2" type="text" placeholder="Nome" class="form-control">
                        </div>
                    </div>

                    <div class="form-group">
                        <div class="input-group">
                            <div class="input-group-prepend">
                                <span class="input-group-text">
                                    <i class="material-icons">email</i>
                                </span>
                            </div>
                            <input id="input-email-contato-2" v-model="emailContato2" type="text" placeholder="E-mail" class="form-control">
                        </div>
                    </div>

                    <div class="form-group">
                        <div class="input-group">
                            <div class="input-group-prepend">
                                <span class="input-group-text">
                                    <i class="material-icons">phone</i>
                                </span>
                            </div>
                            <input id="input-telefone-contato-2" v-model="telefoneContato2" type="text" placeholder="Telefone" class="form-control">
                        </div>
                    </div>

                    <div v-show="success" class="mt-3" style="margin: auto;">
                        <span style="font-weight: bold; margin: auto;">Usuário cadastrado com sucesso!</span>
                    </div>

                    <div v-show="errors" class="mt-3">
                        <ul>
                            <li v-for="(error, i) in errors" :key="i">
                                <span style="font-weight: bold; color: red;">{{ error }}</span>
                            </li>
                        </ul>
                    </div>

                    <button id="actionButton" v-on:click="cadastrarUsuario" style="width: 200px;" class="btn-solar mt-3">Salvar</button>
                </div>
            </div>
        </template>
    </Layout>
</template>

<script>
    import Layout from "@/components/layout/Layout.vue";

    export default {
        data() {
            return {
                nome: null,
                email: null,
                telefone: null,
                senha: null,
                confirmarSenha: null,
                nomeContato1: null,
                emailContato1: null,
                telefoneContato1: null,
                nomeContato2: null,
                emailContato2: null,
                telefoneContato2: null,
                success: false,
                errors: []
            }
        },
        methods: {
            clearForm() {
                this.nome = null;
                this.email = null;
                this.telefone = null;
                this.senha = null;
                this.confirmarSenha = null;
                this.nomeContato1 = null;
                this.emailContato1 = null;
                this.telefoneContato1 = null;
                this.nomeContato2 = null;
                this.emailContato2 = null;
                this.telefoneContato2 = null;
            },
            cadastrarUsuario() {
                if (this.senha == null || this.senha == '') {
                    document.getElementById('input-senha').setCustomValidity('Informe a senha');
                    document.getElementById('input-senha').reportValidity();
                    document.getElementById('input-senha').focus();
                    return false;
                } else {
                    document.getElementById('input-senha').setCustomValidity('');
                }

                if (this.email == null || this.email == '') {
                    document.getElementById('input-email').setCustomValidity('Informe o email');
                    document.getElementById('input-email').reportValidity();
                    document.getElementById('input-email').focus();
                    return false;
                } else {
                    document.getElementById('input-email').setCustomValidity('');
                }

                if (this.telefone == null || this.telefone == '') {
                    document.getElementById('input-telefone').setCustomValidity('Informe o telefone');
                    document.getElementById('input-telefone').reportValidity();
                    document.getElementById('input-telefone').focus();
                    return false;
                } else {
                    document.getElementById('input-telefone').setCustomValidity('');
                }

                if (this.confirmarSenha == null || this.confirmarSenha == '') {
                    document.getElementById('input-confirmar-senha').setCustomValidity('Confirme a senha');
                    document.getElementById('input-confirmar-senha').reportValidity();
                    document.getElementById('input-confirmar-senha').focus();
                    return false;
                } else {
                    document.getElementById('input-confirmar-senha').setCustomValidity('');
                }

                var formData = {
                    'name': this.nome,
                    'email': this.email,
                    'telefone': this.telefone,
                    'password': this.senha,
                    'password_confirmation': this.confirmarSenha,
                    'nome_contato_1': this.nomeContato1,
                    'email_contato_1': this.emailContato1,
                    'telefone_contato_1': this.telefoneContato1,
                    'nome_contato_2': this.nomeContato2,
                    'email_contato_2': this.emailContato2,
                    'telefone_contato_2': this.telefoneContato2
                };

                callAPI(
                    "/register",
                    "post",
                    formData,
                    (res) => {
                        if ( res.success ) {
                            this.success = true;
                            this.errors = null;
                            this.clearForm();
                        } else {
                            this.success = false;
                            this.errors = res.errors;
                        }
                    },
                    (res) => {},
                    (res) => {
                        this.success = false;
                        this.errors = [];
                        for (var key in res.responseJSON.errors) {
                            for ( const error of res.responseJSON.errors[key] ) {
                                this.errors.push(error);
                            }
                        }
                    }
                );
            },
            formatNome(input, nome) {
                if (input) {
                    return input.toUpperCase();
                } else {
                    return null;
                }
            },
            formatTelefone(input) {
                if (input) {
                    input = input.replace(/\D/g,'');

                    var telefone = '';

                    for ( var i = 0; i < input.length && i < 11; i++ ) {
                        if (i == 0) {
                            telefone += '(';
                        } else if (i == 2) {
                            telefone += ') ';
                        } else if (i == 6 && input.length < 11) {
                            telefone += '-';
                        } else if (i == 7 && input.length == 11 ) {
                            telefone += '-';
                        }

                        telefone += input.charAt(i);
                    }

                    return telefone;
                }

                return null;
            }
        },
        components: {
            Layout
        },
        watch: {
            nome(input) {
                this.nome = this.formatNome(input);
            },
            nomeContato1(input) {
                this.nomeContato1 = this.formatNome(input);
            },
            nomeContato2(input) {
                this.nomeContato2 = this.formatNome(input);
            },
            telefone(input) {
                this.telefone = this.formatTelefone(input);
            },
            telefoneContato1(input) {
                this.telefoneContato1 = this.formatTelefone(input);
            },
            telefoneContato2(input) {
                this.telefoneContato2 = this.formatTelefone(input);
            }
        }
    };
</script>